import { isString } from 'class-validator';

import { Nullable } from './globals';

const TRUTHY_QUERY_PARAM_VALUES = new Set(['1', 'true', 'yes']);

/**
 * Parses common query-string truthy values (`1`, `true`, `yes`, case-insensitive).
 * Also accepts boolean `true` and number `1`. Arrays are truthy if any element is.
 */
export function parseTruthyQueryParam(value: unknown): boolean {
  if (value === true || value === 1) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.some(item => parseTruthyQueryParam(item));
  }

  if (!isString(value)) {
    return false;
  }

  return TRUTHY_QUERY_PARAM_VALUES.has(value.trim().toLowerCase());
}

function splitLast(join: string): [string, Nullable<string>] {
  // converts 'foo.bar.baz' into => ['foo.bar', 'baz']
  const lastIndex = join.lastIndexOf('.');
  if (lastIndex === -1) {
    return [join, null];
  }
  const head = join.slice(0, lastIndex);
  const tail = join.slice(lastIndex + 1);
  return [head, tail];
}

export function exhaustJoin(join: string): string[] {
  const result: string[] = [];

  if (!join || typeof join !== 'string') {
    return [];
  }

  let keepGoing = true;
  while (keepGoing) {
    let tail;
    result.push(join);
    [join, tail] = splitLast(join);

    if (!tail) {
      keepGoing = false;
    }
  }

  return result.reverse();
}
